import Vue from 'vue';
import {adminRoles} from '@/enums/userRolesEnum';
import HttpMixin from '@/mixins/HttpMixin';
import TaskDropdown from '@/componentsReusable/tasks/TaskDropdown.vue';
import CreateTaskModal from '@/componentsReusable/tasks/create/CreateTaskModal';
import TaskColumn from '@/componentsReusable/tasks/column/TaskColumn';
import RecentlyCompletedTaskColumn from '@/componentsReusable/tasks/column/RecentlyCompletedTaskColumn';
import IncomingTaskColumn from '@/componentsReusable/tasks/column/IncomingTaskColumn';
import {Task} from '@/interfaces/TaskInterfaces';
import {ViewStateType} from "@/enums/ViewStateType";
import {Column} from '@/interfaces/TaskInterfaces';
import VueSimpleSpinner from "vue-simple-spinner";

export default Vue.extend({
  name: 'Tasks',
  props: {
    'userId': {type: [String, Number]}
  },
  components: {
    TaskDropdown,
    CreateTaskModal,
    TaskColumn,
    RecentlyCompletedTaskColumn,
    IncomingTaskColumn,
    VueSimpleSpinner,
  },
  mixins: [HttpMixin],
  data() {
    return {
      isAuthorized: false,
      showConfirmationModal: false,
      modalTaskId: 0,
      ViewStateType: ViewStateType,
      Column: Column,
    };
  },
  computed: {
    todaysTasks(): Task[] {
      return this.$store.getters["task/getTasksForUserId"](Number(this.userId)).todaysTasks;
    },
    weekTasks(): Task[] {
      return this.$store.getters["task/getTasksForUserId"](Number(this.userId)).weekTasks;
    },
    incomingTasks(): Task[] {
      return this.$store.getters["task/getTasksForUserId"](Number(this.userId)).incomingTasks;
    },
    laterTasks(): Task[] {
      return this.$store.getters["task/getTasksForUserId"](Number(this.userId)).laterTasks;
    },
    waitingTasks(): Task[] {
      return this.$store.getters["task/getTasksForUserId"](Number(this.userId)).waitingTasks;
    },
    completedTasks(): Task[] {
      return this.$store.getters["task/getTasksForUserId"](Number(this.userId)).completedTasks;
    },
    waitingForData(): boolean {
      return this.$store.getters["task/getTasksForUserId"](Number(this.userId)).waitingForData;
    },

  },
  watch: {
    userId () {
      this.checkTaskId();
    }
  },
  created() {
    this.checkTaskId();
  },
  beforeMount: function () {
    this.isAuthorized = this.$store.getters['user/hasRole'](adminRoles);
  },
  methods: {
    checkTaskId() {
      if (!this.userId) {
        this.userChanged(this.$store.state.user.appUserId);
      } else {
        this.$store.commit('task/setUserIdInFocus', Number(this.userId));
      }
    },
    createTask() {
      if (!this.showConfirmationModal) {
        this.showConfirmationModal = true;
      }
    },
    userChanged(newUserId: number) {
      this.$router.replace({ name: 'Tasks', params: { userId: String(newUserId) } });
      this.$store.commit('task/setUserIdInFocus', newUserId);
    },
    taskCreated(newTaskId: number) {
      this.modalTaskId = newTaskId;
      this.showConfirmationModal = false;
    }
  }
});



// WEBPACK FOOTER //
// ./src/components/tasks/Tasks.ts